import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

type Props<T> = {
  items: T[];
  renderCard: (item: T, index: number) => React.ReactNode;
  desktop: React.ReactNode;
};

export function SeoCardsMobileLoop<T>({ items, renderCard, desktop }: Props<T>) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    dragFree: false,
    containScroll: false,
  });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelected(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <div className="mt-6 md:mt-10 flex flex-col gap-5">
      {/* Mobile/tablet: looped embla carousel */}
      <div className="lg:hidden">
        <div className="-mr-4 sm:-mr-6 overflow-hidden" ref={emblaRef}>
          <div className="flex gap-4 sm:gap-5 pr-4 sm:pr-6 pb-2">
            {items.map((s, i) => (
              <div
                key={`m-${i}`}
                className="shrink-0 w-[78%] sm:w-[48%]"
              >
                {renderCard(s, i)}
              </div>
            ))}
          </div>
        </div>
        {/* Dots */}
        <div className="mt-4 flex justify-center gap-1.5">
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Слайд ${i + 1}`}
              onClick={() => emblaApi?.scrollTo(i)}
              className={`h-1.5 rounded-full transition-all ${
                selected === i
                  ? "w-6 bg-primary"
                  : "w-1.5 bg-muted-foreground/40"
              }`}
            />
          ))}
        </div>
      </div>
      {desktop}
    </div>
  );
}
